import { render, staticRenderFns } from "./RecipientList.vue?vue&type=template&id=2fb200ed&scoped=true&"
import script from "./RecipientList.vue?vue&type=script&lang=js&"
export * from "./RecipientList.vue?vue&type=script&lang=js&"
import style0 from "./RecipientList.vue?vue&type=style&index=0&id=2fb200ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb200ed",
  null
  
)

component.options.__file = "RecipientList.vue"
export default component.exports